import {concat, get} from 'lodash';
import * as actionType from './DVRhealthActionsType';

export const initialState = {
  dvrs: [],
  totalDvrs: 0,
  loading: false,
  reportFile: null,
  page: 0,
  pages: 0,
  healthSubscription: {
    loading: false,
    current: false
  }
};


export default (state = initialState, action = {}) => {
  const newState = {...state};
  const {payload} = action;

  switch (action.type) {
    case actionType.LOAD_REQUEST:
      return {...state, loading: true};
    case actionType.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        dvrs: concat(get(state, 'dvrs', []), get(payload, 'dvrs', [])),
        page: payload.page,
        pages: payload.pages
      };
    case actionType.LOAD_FAILURE:
      return {...state, loading: false};
    case actionType.LOAD_TOTALDVR_SUCCESS:
      return {
        ...state,
        totalDvrs: get(payload, 'totalDvrs', 0)
      };
    case actionType.LOAD_TOTALDVR_FAILURE:
      return {...state, totalDvrs: 0};
    case actionType.LOAD_REPORT_SUCCESS:
      return {
        ...state,
        loadingURL: false,
        reportFile: payload.reportFile
      };
    case actionType.GET_SUBSCRIPTION_REQUEST:
      newState.healthSubscription.loading = true;
      return newState;
    case actionType.GET_SUBSCRIPTION_SUCCESS:
      newState.healthSubscription.current = payload;
    case actionType.GET_SUBSCRIPTION_FAIL:
      newState.healthSubscription.loading = false;
      return newState;
    case actionType.SUBSCRIBE_REQUEST:
    case actionType.UNSUBSCRIBE_REQUEST:
      newState.healthSubscription.loading = true;
      return newState;
    case actionType.SUBSCRIBE_SUCCESS:
    case actionType.UNSUBSCRIBE_SUCCESS:
      newState.healthSubscription.current = payload;
    case actionType.SUBSCRIBE_FAIL:
    case actionType.UNSUBSCRIBE_FAIL:
      newState.healthSubscription.loading = false;
      return newState;
    case actionType.LOAD_REPORT_FAILURE:
    case actionType.CLEAR_REPORT_FILE:
      return {...state, reportFile: null};
    case actionType.CLEAR:
      return {...state, ...initialState};
    default:
      return state;
  }
}
